export default __webpack_public_path__ + "static/media/csv.9470c44c.svg";